import { Component } from '@angular/core';
import { UilabMatButton, UilabMatMenuModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface MenuExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-menu-examples',
    templateUrl: './menu-examples.component.html',
    styleUrls: ['./menu-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatButton,
        UilabMatMenuModule,
    ],
})
export class MenuExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-menu--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/menu`;

    readonly examples: readonly MenuExample[] = [
        {
            variant: 'basic',
            label: 'Basic Menu',
            description:
                'Use a basic menu to show a short list of related actions from a trigger button.',
            htmlSnippet: `<button uilabMatButton="outlined" [uilabMatMenuTriggerFor]="basicMenu">
    Open menu
</button>

<uilab-mat-menu #basicMenu="uilabMatMenu">
    <button uilab-mat-menu-item>Refresh data</button>
    <button uilab-mat-menu-item>Duplicate view</button>
    <button uilab-mat-menu-item>Export CSV</button>
</uilab-mat-menu>`,
        },
    ];
}
